"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityDayStatus = void 0;
var AvailabilityDayStatus;
(function (AvailabilityDayStatus) {
    AvailabilityDayStatus[AvailabilityDayStatus["Active"] = 0] = "Active";
    AvailabilityDayStatus[AvailabilityDayStatus["Inactive"] = 1] = "Inactive";
    AvailabilityDayStatus[AvailabilityDayStatus["Assigned"] = 2] = "Assigned";
    AvailabilityDayStatus[AvailabilityDayStatus["Empty"] = 3] = "Empty";
})(AvailabilityDayStatus || (exports.AvailabilityDayStatus = AvailabilityDayStatus = {}));
//# sourceMappingURL=AvailabilityDayStatus.js.map